// extracted by mini-css-extract-plugin
export default {"list":"menu_list__f3+qq","listItem":"menu_listItem__3VNKf","active":"menu_active__mId1p"};